/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_NDolar_78_36(e) {
  let t = (0, ReactCompiler.c)(7),
    { titulo: n, valor: r } = e,
    i;
  t[0] === n
    ? (i = t[1])
    : ((i = <p className={`text-xs text-(--text)`} children={n} />),
      (t[0] = n),
      (t[1] = i));
  let a = r || `—`,
    o;
  t[2] === a
    ? (o = t[3])
    : ((o = <p className={`break-words text-(--text-h)`} children={a} />),
      (t[2] = a),
      (t[3] = o));
  let s;
  return (
    t[4] !== i || t[5] !== o
      ? ((s = <div children={[i, o]} />), (t[4] = i), (t[5] = o), (t[6] = s))
      : (s = t[6]),
    s
  );
}
